import React, {useEffect, useState} from 'react';
import Select from "react-select";
import {forEach} from "lodash";
import {Typography} from "@material-tailwind/react";
import {BsDatabase, BsSearch} from "react-icons/bs";


const SelectInput = ({
                       className,
                       defaultValue,
                       options,
                       autoLoadService,
                       autoLoadServiceData,
                       autoLoadRender,
                       onChange,
                       label,
                       refreshSignal,
                       multiselect,
                       title,
                       setTitle,
                       description,
                       setDescription,
                       name,
                       setName,
                       family,
                       setFamily,
                     }) => {
  const [selectedOption, setSelectedOption] = useState(multiselect ? [] : "");
  const [optionList, setOptionList] = useState([]);

  const decorateSelectDate = function (lst) {
    const res = [];
    forEach(lst, item => {
      const new_item = {
        value: item.id,
        label: autoLoadRender ? autoLoadRender(item) : item.title
      }
      if (title) {
        new_item.title = item.title;
      }
      if (description) {
        new_item.description = item.description;
      }
      if (name) {
        new_item.name = item.name;
      }
      if (family) {
        new_item.family = item.family;
      }
      res.push(new_item)
    })
    return res;
  };

  useEffect(() => {
    if (defaultValue) {
      if (multiselect) {
        setSelectedOption([]);
        const opts = defaultValue
          .map(value => optionList.find(option => option.value === value))
          .filter(option => option !== undefined);

        setSelectedOption(opts);
      } else {
        setSelectedOption(null);
        const defaultOption = optionList.find(option => option.value === defaultValue);
        if (defaultOption) {

          setSelectedOption(defaultOption);
        }
      }
    }
  }, [optionList]);

  useEffect(() => {
    if (title) {
      setTitle(selectedOption ? selectedOption.title : "");
    }
    if (description) {
      setDescription(selectedOption ? selectedOption.description : "");
    }
    if (name) {
      setName(selectedOption ? selectedOption.name : "");
    }
    if (family) {
      setFamily(selectedOption ? selectedOption.family : "");
    }
  }, [selectedOption]);

  useEffect(() => {
    if (!refreshSignal) {
      setSelectedOption(null)
    }

    if (options) {
      const result = decorateSelectDate(options);
      setOptionList(result)
    }

    if (autoLoadService) {
      async function getData() {
        const result = await autoLoadService(autoLoadServiceData);
        if (result.status === 200) {
          const res = result.data;
          if (Object.values(res) &&
            Object.values(res)[0] &&
            Array.isArray(Object.values(res)[0])) {
            const result = decorateSelectDate(Object.values(res)[0]);
            setOptionList(result);
          }
        }
      }

      getData();
    }
  }, [refreshSignal || null]);

  return (
    <div className="flex flex-row justify-between w-full">
      <Typography className="pl-2 my-auto text-gray-500 font-thin w-1/4" variant="small">
        {label}:
      </Typography>
      <div className="w-full">
        <Select
          value={selectedOption}
          onChange={(option) => {
            setSelectedOption(option);
            if (multiselect) {
              onChange(option.map(o => o.value));
            } else {
              onChange(option.value);
            }
          }}
          options={optionList}
          noOptionsMessage={() => {
            return <Typography className="text-sm flex flex-row justify-center gap-x-2">
              <BsDatabase className="text-lg"/>
              بدون اطلاعات
            </Typography>
          }}
          isSearchable={true}
          isMulti={multiselect}
          placeholder={
            <Typography className="text-sm flex flex-row gap-x-2">
              <BsSearch className="text-md"/>
              جست‌و‌جو...
            </Typography>
          }
          className={`${className}`}
        />
      </div>

    </div>
  );
};

export default SelectInput;